import React from 'react'
import * as RiIcons from 'react-icons/ri';

function Contacto() {
    
    const [ nombre, setNombre] = React.useState('');
    const [ correo, setCorreo] = React.useState('');
    const [ solicitud, setSolicitud] = React.useState('');

    const onChangeCorreo=(event)=>{
        setCorreo(event.target.value);
    }
    const onChangeNombre=(event)=>{
        setNombre(event.target.value);
    }
    const onChangeSolicitud=(event)=>{
        setSolicitud(event.target.value);
    }

    const onSubmit=()=> {
        console.log('Enviar datos de la solicitud');
    }
  return (
    <div style={{display:'flex',flexDirection:'row'}}>
        <div style={{padding: '90px 10px 10px 10px',width:'100%'}}>
            <label className='boton__solicitud' >CONTACTO</label>
            <form className='form__contacto' onSubmit={onSubmit}>
                <label style={{fontFamily:'Source Sans Pro',color:'#0B149D',fontSize:'22px',fontWeight:'bold'}}>Comunícate con nosotros</label>
                <div className='form-group'>
                </div>
                <div style={{display:'flex'}}>
                    <div style={{width:'45%'}} className="form-group" > 
                        <label className='label__contacto'>Nombre </label>
                        <input className='form-control' type='input' value={nombre} onChange={onChangeNombre}></input>
                    </div>
                    <div  style={{position:'relative',left:'10%',width:'45%'}} className="form-group" > 
                        <label className='label__contacto'>Correo </label>
                        <input className='form-control' type='input' value={correo} onChange={onChangeCorreo}></input>
                    </div>
                </div>
                
                <div className='form-group'>
                    <label className='label__contacto'>Cuéntanos  en que podemos ayudarte</label>
                    <textarea style={{height:'150px'}} className='form-control' value={solicitud} onChange={onChangeSolicitud}></textarea>
                </div>
                <button style={{right:'20%',bottom:'1px',position:'absolute'}} className='boton__solicitud' >
                    ENVIAR <RiIcons.RiArrowRightFill/>
                </button>
            </form>
        </div>
        <img className='fondo__contacto' src='/bkg-img-06.svg'></img>
        
    </div>
  )
}

export {Contacto};
